// label for one account: custom name wins, then name, then '(unnamed account)';
// mask appended as ' ··1234' when present. Never returns an empty string.
export function accountOptionLabel(tx) {
  const customName = String(tx?.accountCustomName ?? '').trim();
  const accountName = String(tx?.accountName ?? '').trim();
  const name = customName || accountName || '(unnamed account)';
  const mask = String(tx?.accountMask ?? '').trim();
  return mask ? `${name} ··${mask}` : name;
}

// Build the dropdown options from the loaded rows.
export function buildAccountOptions(transactions, { selected = '', knownLabels } = {}) {
  const accounts = new Map();
  for (const tx of transactions ?? []) {
    const id = tx?.plaidAccountId;
    if (!id || accounts.has(id)) continue;
    accounts.set(id, {
      label: accountOptionLabel(tx),
      value: id,
      mask: tx?.accountMask ?? null,
      accountType: tx?.accountType ?? null,
    });
  }

  const options = [...accounts.values()].sort((a, b) => {
    const aIsCredit = a.accountType === 'credit';
    const bIsCredit = b.accountType === 'credit';
    if (aIsCredit !== bIsCredit) return aIsCredit ? -1 : 1;
    return a.label.localeCompare(b.label, undefined, { sensitivity: 'base' });
  });

  if (selected && !accounts.has(selected)) {
    const knownLabel = knownLabels?.get(selected) || 'Selected account';
    options.push({
      label: `${knownLabel} (none in range)`,
      value: selected,
      mask: null,
      accountType: null,
    });
  }

  return [{ label: 'All Accounts', value: '' }, ...options];
}
